import { render, staticRenderFns } from "./DataTableNotificacoes.vue?vue&type=template&id=68ad3d8e&scoped=true&"
import script from "./DataTableNotificacoes.vue?vue&type=script&lang=js&"
export * from "./DataTableNotificacoes.vue?vue&type=script&lang=js&"
import style0 from "./DataTableNotificacoes.vue?vue&type=style&index=0&id=68ad3d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad3d8e",
  null
  
)

export default component.exports